var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "video-player" },
    [
      !_vm.isRPI
        ? _c("video", {
            ref: "video",
            staticClass: "video-player__video",
            attrs: {
              src: _vm.isHls ? undefined : _vm.getUrl(_vm.src),
              autoplay: _vm.autoplay,
              loop: _vm.loop,
              preload: "auto",
              playsinline: "",
              "webkit-playsinline": ""
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.controls && !_vm.isRPI
        ? _c("VodControls", {
            attrs: {
              "is-visible": _vm.isOsdVisible,
              state: _vm.playerState,
              speed: _vm.playerSpeed,
              "current-time": _vm.playerTime,
              duration: _vm.playerDuration,
              title: _vm.title
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e800649", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e800649","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoPlayer/VideoPlayer.vue
// module id = null
// module chunks = 